import { Product } from '@shared/generated'

/**
 * Возвращает массив изображений товара:
 * 1. сначала product.images, если они есть
 * 2. затем product.preview (если нет изображений в product.images)
 * 3. затем дефолтная заглушка (если для товара отсутствуют product.images и product.preview.url одновременно)
 */

export function getProductGalleryImages (product: Product, fullSize: boolean): string[] {
  const fallbackImage = '/icons/flower-grey.svg'

  const images: string[] = []

  if (product.preview?.url) {
    if (fullSize && product.fullPreview?.url) {
      images.push(product.fullPreview.url)
    }
    else {
      images.push(product.preview.url)
    }
  }

  if (product.images?.length) {
    if (fullSize && product.galleryImages?.length) {
      images.push(...product.galleryImages.map((img) => img?.url).filter((url): url is string => Boolean(url)))
    }
    else {
      images.push(...product.images.map((img) => img?.url).filter((url): url is string => Boolean(url)))
    }
  }
  
  if (!product.preview?.url && !product.images?.length) {
    images.push(fallbackImage)
  }

  return images
}
